/* eslint-disable react/jsx-no-undef */
'use client';
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { getLastestClientIndicator } from '@/services/apis/modules/indicators';
import { IIndicatorItem } from '@/interfaces/indicator';
import Icon from '@/components/atoms/icon';
import Skeleton from '@/components/atoms/skeletons';
import dynamic from 'next/dynamic';
import { useGetLatestChartData } from '@/helpers/useGetLastestChartData';
import { useData } from '@/stores/context';
import Empty from '@/components/atoms/empty';
import useDirectDetail from '@/helpers/useDirectDetail';
import Tabs from '@/components/atoms/tabs';
import ChartPackageSkeleton from '@/components/molecules/skeleton-component/chartPacakge';
import { Tour } from 'antd';
import Modal from '@/components/molecules/modal';
import Button from '@/components/atoms/button';
import { FaArrowAltCircleRight, FaChartArea } from 'react-icons/fa';
import { mapModifiers, slugify } from '@/utils/funtion';
import Image from 'next/image';
import imageStar from '@/assets/images/starling.png';
import dayjs from 'dayjs';
import { clearDetailUrl } from '@/stores/modules/detailUrl';
import { useDispatch } from 'react-redux';

const ChartPackage = dynamic(
  () => import('@/components/templates/chartPackage'),
  {
    ssr: false,
    loading: () => {
      return <ChartPackageSkeleton />;
    },
  },
);

const RequestUpdateInfo = dynamic(
  () => import('@/components/organisms/request-update-info'),
  { ssr: false },
);

export default function HomeLastestIndicatorTabs({
  homepage,
}: {
  homepage?: boolean;
}) {
  const {
    setIndicatorSummary,
    innerWidth,
    isPauseAutoPlay,
    handleSetAutoPlay,
  } = useData();
  const { handleDirectDetail } = useDirectDetail();
  const { chartData, loading, handleGetChartData, handleGetChartDataByRange } =
    useGetLatestChartData();
  const [isLoading, setIsLoading] = useState(true);
  const [active, setActive] = useState({
    key: 'latest',
    id: null as string | null,
  });
  const dispatch = useDispatch();

  const indicatorListRef = useRef(null);
  const chartRef = useRef(null);

  const [open, setOpen] = useState({
    modalTour: false,
    tour: false,
  });

  const [classNames, setClassNames] = useState({
    selectTypeChart: null as any,
    range: null as any,
    api: null as any,
    compare: null as any,
    viewIndicator: null as any,
    zoom: null as any,
    download: null as any,
    detail: null as any,
    search: null as any,
    profile: null as any,
    plans: null as any,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const selectTypeChart =
        document.getElementsByClassName('select-type-chart');
      const range = document.getElementsByClassName(
        't-chart_package_header_time',
      );
      const api = document.getElementsByClassName(
        't-chart_package_header_right_view_data-api',
      );
      const compare = document.getElementsByClassName(
        't-chart_package_header_right_view_data-compare',
      );
      const viewIndicator = document.getElementsByClassName(
        't-chart_package_header_right_view_data-eye',
      );
      const zoom = document.getElementsByClassName(
        't-chart_package_header_right_view_data-fullscreen',
      );
      const download = document.getElementsByClassName(
        't-chart_package_header_right_view_data-download',
      );
      const detail = document.getElementsByClassName(
        't-chart_package_header_right_view_data-to-detail',
      );
      const search = document.getElementsByClassName('t-search_engine');
      const profile = document.getElementsByClassName('a-user_dropdown');
      const plans = document.getElementsByClassName('a-button-plans-button');
      setClassNames({
        selectTypeChart: selectTypeChart,
        range: range,
        api: api,
        compare: compare,
        viewIndicator: viewIndicator,
        zoom: zoom,
        download: download,
        search: search,
        profile: profile,
        detail: detail,
        plans: plans,
      });
    }
  }, []);

  useEffect(() => {
    dispatch(clearDetailUrl());
  }, []);

  const steps = [
    {
      title: 'Danh sách chỉ số',
      description:
        'Khi bạn chọn bất kỳ chỉ số ở đây thì dữ liệu của chỉ số sẽ hiển thị ở biểu đồ bên cạnh',
      target: () => indicatorListRef?.current || document.body,
      nextButtonProps: { children: 'Tiếp theo' },
    },
    {
      title: 'Biểu đồ chỉ số',
      description:
        'Ở đây bạn có thể xem số liệu của chỉ số thông qua nhiều loại biểu đồ khác nhau.',
      target: () => chartRef?.current || document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Tùy chỉnh biểu đồ',
      description: 'Bọn có thể thay đổi loại biểu đồ chỉ số tùy theo như cầu',
      target: () =>
        classNames.selectTypeChart && classNames.selectTypeChart?.length > 0
          ? classNames.selectTypeChart[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: { children: 'Tiếp theo' },
    },
    {
      title: 'Chọn khoảng thời gian thống kê',
      description:
        'Bạn có thể thay đổi khoảng thời nhất định mà mình muốn xem thông kê',
      target: () =>
        classNames.range && classNames.range?.length > 0
          ? classNames.range[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'API',
      description:
        'Bạn có thể đăng ký nhận API của chỉ số ở đây',
      target: () =>
        classNames.api && classNames.api?.length > 0
          ? classNames.api[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'So sánh chỉ số',
      description:
        'Bạn có thể so sánh các chỉ số ở đây',
      target: () =>
        classNames.compare && classNames.compare?.length > 0
          ? classNames.compare[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Xem dữ liệu',
      description:
        'Bạn có thể lựu chọn hiển thị hoặc ẩn dữ liệu của các đối tượng trên biểu đồ',
      target: () =>
        classNames.viewIndicator && classNames.viewIndicator?.length > 0
          ? classNames.viewIndicator[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Phóng to biểu đồ',
      description: 'Bạn có thể phóng to biểu đồ toàn màn hình',
      target: () =>
        classNames.zoom && classNames.zoom?.length > 0
          ? classNames.zoom[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Tải xuống biểu đồ',
      description:
        'Ở đây bạn có thể tải xuống biểu đồ ở các định dạng như PDF, Hình ảnh, Excel...',
      target: () =>
        classNames.download && classNames.download?.length > 0
          ? classNames.download[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Xem trang chi tiết chỉ số',
      description: 'Bạn có thể vào trang chí tiết của chỉ số ở đ',
      target: () =>
        classNames.detail && classNames.detail?.length > 0
          ? classNames.detail[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    // {
    //   title: 'Tìm kiếm dữ liệu',
    //   description: 'Bạn có thể tìm kiếm các chỉ số cụ thể ở đây',
    //   target: () =>
    //     classNames.search && classNames.search?.length > 0
    //       ? classNames.search[0]
    //       : document.body,
    //   prevButtonProps: { children: 'Trước đó' },
    //   nextButtonProps: {
    //     children: 'Tiếp theo',
    //   },
    // },
    {
      title: 'Thông tin tài khoản',
      description: 'Bạn có thể xem thông tin tài khoản của mình ở đây',
      target: () =>
        classNames.profile && classNames.profile?.length > 0
          ? classNames.profile[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Tiếp theo',
      },
    },
    {
      title: 'Các gói dữ',
      description: 'Bạn có thể mua gói dữ liệu ở đây',
      target: () =>
        classNames.plans && classNames.plans?.length > 0
          ? classNames.plans[0]
          : document.body,
      prevButtonProps: { children: 'Trước đó' },
      nextButtonProps: {
        children: 'Hoàn thành',
      },
    },
  ];

  const [indicatorLastest, setIndicatorLastest] = useState({
    data: [] as IIndicatorItem[],
    isFetched: false,
    sumary: [] as IIndicatorItem[],
  });

  const [indicatorPopular, setIndicatorPopular] = useState({
    data: [] as IIndicatorItem[],
    isFetched: false,
    sumary: [] as IIndicatorItem[],
  });

  const items = useMemo(
    () => [
      {
        key: 'latest',
        label: 'Dữ liệu mới nhất',
        children: (
          <IndicatorTabList
            onClickToDetail={handleDirectDetail}
            data={indicatorLastest.data}
            loading={isLoading}
            onItemClick={(id: string, type: string, index) => {
              handleGetChartData(id, type);
              setActive((prev) => ({
                ...prev,
                id,
              }));
              setLatestIndex(index);
              handleSetAutoPlay(true);
            }}
            activeIndicatorId={active.id}
          />
        ),
      },
      {
        key: 'popular',
        label: 'Dữ liệu phổ biến',
        children: (
          <IndicatorTabList
            onClickToDetail={handleDirectDetail}
            data={indicatorPopular.data}
            loading={isLoading}
            onItemClick={(id: string, type: string, index) => {
              handleGetChartData(id, type);
              setActive((prev) => ({
                ...prev,
                id,
              }));
              setPopularIndex(index);
              handleSetAutoPlay(true);
            }}
            activeIndicatorId={active.id}
          />
        ),
      },
    ],
    [indicatorLastest.data, isLoading, active.id, indicatorPopular.data],
  );

  useLayoutEffect(() => {
    handleGetLastistIndicator();
  }, [active.key]);

  useLayoutEffect(() => {
    if (active.key === 'latest') {
      setIndicatorSummary(indicatorLastest.sumary);
    } else if (active.key === 'popular')
      setIndicatorSummary(indicatorPopular.sumary);
  }, [active.key, indicatorLastest, indicatorPopular]);

  const [latestIndex, setLatestIndex] = useState(0);
  const [popularIndex, setPopularIndex] = useState(0);

  useEffect(() => {
    if (isPauseAutoPlay) return;
    let interval: any;

    const startInterval = () => {
      if (active.key === 'latest' && indicatorLastest.data.length > 0) {
        setActive((prev) => ({
          ...prev,
          id: indicatorLastest.data[latestIndex].id,
        }));
        handleGetChartData(
          indicatorLastest.data[latestIndex].id,
          indicatorLastest.data[latestIndex].type,
        );
        interval = setInterval(() => {
          setLatestIndex((prevIndex) => {
            const nextIndex = (prevIndex + 1) % indicatorLastest.data.length;
            setActive((prev) => ({
              ...prev,
              id: indicatorLastest.data[nextIndex].id,
            }));
            handleGetChartData(
              indicatorLastest.data[nextIndex].id,
              indicatorLastest.data[nextIndex].type,
            );
            return nextIndex;
          });
        }, 16000);
      }

      if (active.key !== 'latest' && indicatorPopular.data.length > 0) {
        setActive((prev) => ({
          ...prev,
          id: indicatorPopular.data[popularIndex].id,
        }));
        handleGetChartData(
          indicatorPopular.data[popularIndex].id,
          indicatorPopular.data[popularIndex].type,
        );
        interval = setInterval(() => {
          setPopularIndex((prevIndex) => {
            const nextIndex = (prevIndex + 1) % indicatorPopular.data.length;
            setActive((prev) => ({
              ...prev,
              id: indicatorPopular.data[nextIndex].id,
            }));
            handleGetChartData(
              indicatorPopular.data[nextIndex].id,
              indicatorPopular.data[nextIndex].type,
            );
            return nextIndex;
          });
        }, 16000);
      }
    };

    if (!isPauseAutoPlay) {
      startInterval();
    }

    return () => clearInterval(interval);
  }, [
    active.key,
    indicatorLastest.data,
    indicatorPopular.data,
    isPauseAutoPlay,
  ]);

  const handleGetLastistIndicator = async () => {
    setIsLoading(true);
    if (active.key === 'latest' && !indicatorLastest.isFetched) {
      const result = await getLastestClientIndicator({ type: 'latest' });
      if (result) {
        setIndicatorLastest({
          data: result?.table,
          isFetched: true,
          sumary: result?.summary,
        });
      }
    } else if (active.key === 'popular' && !indicatorPopular.isFetched) {
      const result = await getLastestClientIndicator({ type: 'popular' });
      if (result) {
        setIndicatorPopular({
          data: result?.table,
          isFetched: true,
          sumary: result?.summary,
        });
      }
    }
    setIsLoading(false);
  };

  const onChange = (key: string) => {
    setActive({
      key: key,
      id: null,
    });
  };

  const memoryChart = useMemo(
    () => (
      <ChartPackage
        data={
          !chartData?.isStructure &&
          !chartData?.isTwoUnit &&
          !chartData?.isObjectOneTime
            ? chartData?.indicatorValue
            : chartData?.children
        }
        isHomePage={homepage}
        name={chartData?.name}
        slug={slugify(chartData?.name)}
        original={chartData?.original}
        unit={chartData?.unit}
        isTwoUnit={chartData?.isTwoUnit}
        isStructure={chartData?.isStructure}
        originalUrl={chartData?.originalUrl}
        id={chartData?.id}
        isObjectOneTime={chartData?.isObjectOneTime}
        dataType={chartData?.dataType}
        chartType={chartData?.chartType || 'column'}
        loading={loading}
        handleClickRangeTime={handleGetChartDataByRange}
        typeData={chartData?.type_data}
        parentId={chartData?.parentId}
        isTopPgae
      />
    ),
    [chartData, chartData?.original, loading],
  );

  const memoUpdateInfo = useMemo(
    () => (
      <RequestUpdateInfo
        onFinish={() =>
          setOpen({
            ...open,
            modalTour: true,
          })
        }
      />
    ),
    [],
  );
  return (
    <div className="c-home_pin">
      <span ref={chartRef}>{memoryChart}</span>
      <div className="t-home-lastest-indicator" ref={indicatorListRef}>
        <Tabs defaultActiveKey="latest" items={items} onChange={onChange} />
      </div>
      {memoUpdateInfo}
      {/* <BetaWelcomeModal /> */}
      {innerWidth > 789 && (
        <Tour
          open={open.tour}
          onClose={() =>
            setOpen({
              ...open,
              tour: false,
            })
          }
          steps={steps}
          closeIcon={true}
        />
      )}
      {innerWidth > 789 && (
        <Modal
          open={open.modalTour}
          footer={false}
          width={500}
          centered
          closable={true}
          className="o-report-modal o-tour-modal"
          onCancel={() => {
            setOpen({
              modalTour: false,
              tour: false,
            });
          }}
        >
          <div className="o-report-modal_image">
            <Image src={imageStar} alt="Hướng dẫn" loading="lazy" />
          </div>
          <div className="o-report-modal_title">
            Sau đây là một số hướng dẫn cơ bản của website
          </div>
          <div className="o-report-modal_action">
            <Button
              ariaLabel="Bắt đầu"
              shape="fill"
              variant="secondary"
              onClick={() =>
                setOpen({
                  modalTour: false,
                  tour: true,
                })
              }
            >
              Bắt đầu
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
}

const IndicatorTabList = ({
  data,
  loading,
  onItemClick,
  activeIndicatorId,
  onClickToDetail,
}: {
  data: any;
  loading: boolean;
  onItemClick: (id: string, type: string, index: number) => void;
  activeIndicatorId: string | null;
  onClickToDetail: any;
}) => {
  return (
    <div className="indicator-tab-list">
      {loading ? (
        Array(10)
          ?.fill(null)
          .map((_, index) => (
            <React.Fragment key={index}>
              <Skeleton
                active
                loading
                paragraph={{ rows: 2, maxWidth: 1380, width: '100%' }}
              />
            </React.Fragment>
          ))
      ) : data && data.length > 0 ? (
        data?.map((item: any, index: number) => {
          // const isToday =
          //   new Date(item.updatedAt).toDateString() ===
          //   new Date().toDateString();
          const isToday = dayjs(item.updatedAt).isAfter(
            dayjs().subtract(3, 'day'),
          );
          return (
            <div
              className={mapModifiers(
                `indicator-tab-item`,
                item?.id === activeIndicatorId && 'active',
              )}
              key={item?.id}
              onClick={() => onItemClick(item?.id, item?.type, index)}
            >
              <div className="indicator-tab-item_icon">
                <Icon
                  component={
                    item?.id === activeIndicatorId ? (
                      <FaArrowAltCircleRight style={{ color: '#05d335' }} />
                    ) : (
                      <FaChartArea />
                    )
                  }
                />
              </div>
              <p>
                {item?.name}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickToDetail(
                      item.slug,
                      item.id,
                      item.type,
                      item.isStructure,
                      item.isObjectOneTime,
                    );
                  }}
                >
                  [Chi tiết]
                </span>
              </p>
              {isToday && (
                <div className="indicator-tab-item_new">
                  <Icon iconName="newest" size="28x28" />
                </div>
              )}
            </div>
          );
        })
      ) : (
        <Empty />
      )}
    </div>
  );
};
